const disableLogging = process.env.DisableLogging || false;

export const log = (...logs) => {
    if (!disableLogging) {
        /* eslint-disable no-console */
        logs.forEach((logItem) => {
            let output = logItem;

            if (typeof logItem === "object") {
                output = JSON.stringify(logItem);
            }

            console.log(`%c DEBUG: ${output}`, "color: #518dcf");
        });
    }
};

export const error = (...logs) => {
    if (!disableLogging) {
        /* eslint-disable no-console */
        logs.forEach((logItem) => {
            let output = logItem;

            if (typeof logItem === "object") {
                output = JSON.stringify(logItem);
            }

            console.log(`%c ERROR: ${output}`, "color: #ff1133");
        });
    }
};
